import { render, staticRenderFns } from "./AddressHeader.vue?vue&type=template&id=e06432f4&scoped=true"
import script from "./AddressHeader.vue?vue&type=script&lang=js"
export * from "./AddressHeader.vue?vue&type=script&lang=js"
import style0 from "./AddressHeader.vue?vue&type=style&index=0&id=e06432f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06432f4",
  null
  
)

export default component.exports